import { render } from "./OpennessOrganizationReports.vue?vue&type=template&id=29863276&scoped=true"
import script from "./OpennessOrganizationReports.vue?vue&type=script&lang=js"
export * from "./OpennessOrganizationReports.vue?vue&type=script&lang=js"

import "./OpennessOrganizationReports.vue?vue&type=style&index=0&id=29863276&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29863276"]])

export default __exports__